const JURISTIC_TYPE = {
    bitNeurceno: 0,
    bitVlastniUzivani: 1,
    bitPropachtovatel: 2,
    bitOstatni: 3,
    bitVReseni: 4
}

export default JURISTIC_TYPE